import React, { useState, useEffect } from "react";
import { Form, Button, Card } from "react-bootstrap";  // Removed Modal import
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useGlobalState } from "../../../services/hostelConst";
import {
  addHostelFoodMenu,
  updateHostelFoodMenu,
} from "../../../services/OrganisationServices/hostelManagmentService";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "./hostel.css";

const AddFoodMenuComponent = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const hostelId = modalState.id;
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    date: "",
    note: "",
    hostelId,
    id: null,
  });

  const [errors, setErrors] = useState({});
  
  const parseDate = (dateString) => {
    if (!dateString) return null;
    
    if (dateString instanceof Date) return dateString;
    
    const parts = dateString.split('/');
    if (parts.length === 3) {
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
    
    const fallbackDate = new Date(dateString);
    return isNaN(fallbackDate.getTime()) ? null : fallbackDate;
  };
  
  useEffect(() => {
    if (masterData) {
      setFormData({
        date: masterData.DATE || "",
        note: masterData.NOTE || "",
        hostelId,
        id: masterData._ID || null,
      });
    }
  }, [masterData, hostelId]);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleDateChange = (date) => {
    let formattedDate = "";
    if (date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      formattedDate = `${day}/${month}/${year}`;
    }
    
    setFormData((prev) => ({
      ...prev,
      date: formattedDate,
    }));
    setErrors((prev) => ({ ...prev, date: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.note?.trim()) newErrors.note = "Note is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    // Direct submission without confirmation modal
    setIsLoading(true);

    try {
      const response = masterData
        ? await updateHostelFoodMenu(formData)
        : await addHostelFoodMenu(formData);

      if (response.status === "success") {
        callToast(
          "success",
          "Success",
          `Food menu ${masterData ? "updated" : "added"} successfully!`
        );

        await refresh({ columnRefresh: false, isLoading: false });
        closeModal();
      } else {
        showErrorMessages({ data: response, navigate });
      }
    } catch (error) {
      console.error("Error:", error);
      callToast("error", "Error", "An unexpected error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card.Body className="px-4 py-4">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-4">
          <Form.Label className="fw-bold">Date</Form.Label>
          <ReactDatePicker
            selected={parseDate(formData.date)}
            onChange={(date) => {
              handleDateChange(date);
            }}
            dateFormat="dd/MM/yyyy"
            className={`form-control ${errors.date ? "is-invalid" : ""}`}
            placeholderText="Select date"
            isClearable
            showYearDropdown
            scrollableYearDropdown
          />
          {errors.date && (
            <div className="invalid-feedback d-block">{errors.date}</div>
          )}
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label className="fw-bold">Note</Form.Label>
          <Form.Control
            as="textarea"
            name="note"
            value={formData.note}
            onChange={handleInputChange}
            placeholder="Enter menu details or special notes"
            rows={5}
            isInvalid={!!errors.note}
            className="shadow-sm"
          />
          <Form.Control.Feedback type="invalid">
            {errors.note}
          </Form.Control.Feedback>
        </Form.Group>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading}
            className="px-4"
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {masterData ? "Updating..." : "Adding..."}
              </>
            ) : (
              masterData ? "Update Food Menu" : "Add Food Menu"
            )}
          </Button>
        </div>
      </Form>
    </Card.Body>
  );
};

export default AddFoodMenuComponent;